import React, { useState, useEffect } from "react";
//import PageModal from "../modal/modal";
import {
  getAllPages,
  deletePage,
  getAllSearchPages,
  getAllUsers,
} from "../../api/api";
import Listloader from "../loader/content";
import InfiniteScroll from "react-infinite-scroll-component";
import toastr from "toastr";
import "toastr/build/toastr.min.css";
import Loader from "../loader/loader";
import "../pages/search.css";
import EditUser from "../modal/editUser";
import { Link } from "react-router-dom";
// import { UserDetail } from "../../store/userStore";

const UserList = (props) => {
  const [ModalShow, setModalShow] = useState(false);
  const [allPage, setallPage] = useState([]);
  const [pageNum, setPageNum] = useState(0);
  const [hasHigh, sethasHigh] = useState(true);
  const [loading, setLoading] = useState(false);
  const [query, setQuery] = useState("");
  const [search, setSearch] = useState(false);
  const [selectedUser, setSelectedUser] = useState([]);

  useEffect(() => {
    const getPage = async () => {
      setLoading(true);
      try {
        const appl = await getAllUsers(10, 0);

        const pages = appl.data.users;
        // UserDetail.update((s) => {
        //   s.detail = appl.data.count;
        // });
        const imageCount = appl.data.count;

        setallPage(pages);

        setPageNum(imageCount);
        if (imageCount === appl.data.users.length) {
          sethasHigh(false);
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };
    getPage();
  }, []);

  const handleDelete = async (event, id, index) => {
    const removeId = index;
    event.preventDefault();
    const items = Array.from(allPage);
    items.splice(removeId, 1);
    setallPage(items);
    if (id !== undefined && id !== "") {
      try {
        /* eslint-disable no-unused-vars */
        const result = await deletePage(id);
        /* eslint-disable no-unused-vars */
        toastr.success("Successfully Deleted", "Success");
      } catch (error) {
        toastr.error("Error in deleting the Image", "Error");
      }
    } else {
      toastr.error("Delete Id is Missing", "Error");
    }
  };
  const fetchData = async () => {
    if (
      (!search && (query === "" || query !== "")) ||
      (search && query === "")
    ) {
      const length = allPage.length;
      try {
        const appl = await getAllUsers(length + 10, length);

        const pages = appl.data.users;

        const imageCount = appl.data.count;

        setPageNum(imageCount);
        const newArray = [...allPage, ...pages];

        setallPage(newArray);
        setPageNum(imageCount);
        if (pageNum === allPage.length) {
          sethasHigh(false);
        }
      } catch (error) {}
    } else {
      const length = allPage.length;
      try {
        const appl = await getAllSearchPages(length + 10, length, query);

        const pages = appl.data.pages;

        const imageCount = appl.data.count;

        setPageNum(imageCount);
        const newArray = [...allPage, ...pages];

        setallPage(newArray);
        setPageNum(imageCount);
        if (pageNum === allPage.length) {
          sethasHigh(false);
        }
      } catch (error) {}
    }
  };

  const getSearchResult = async () => {
    setLoading(true);

    try {
      const appl = await getAllSearchPages(10, 0, query);
      const pages = appl.data.pages;

      const imageCount = appl.data.count;

      setallPage(pages);
      setPageNum(imageCount);
      if (imageCount === appl.data.pages.length) {
        sethasHigh(false);
      }
      if (appl.data.pages.length < appl.data.limit) {
        sethasHigh(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const getPageStart = async () => {
    sethasHigh(true);
    setLoading(true);
    try {
      const appl = await getAllPages(10, 0);

      const pages = appl.data.pages;

      const imageCount = appl.data.count;

      setallPage(pages);
      setPageNum(imageCount);
      if (imageCount === appl.data.pages.length) {
        sethasHigh(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };
  //
  if (loading) {
    return (
      <div className="content">
        <Loader />
      </div>
    );
  } else {
    return (
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card ">
                <div className="card-header filter">
                  <h3 className="card-title">Users</h3>

                  <ul className="navbar-nav ml-auto ">
                    <li className="nav-item">
                      <a
                        className="nav-link"
                        data-widget="navbar-search"
                        href="#!"
                        role="button"
                        onClick={(event) => {
                          event.preventDefault();
                          setSearch(!search);
                        }}
                      >
                        <i className="fas fa-search"></i>
                      </a>
                      <div
                        className={
                          search
                            ? "navbar-search-block"
                            : "navbar-search-block none"
                        }
                      >
                        <form
                          className="form-inline"
                          onSubmit={(event) => {
                            event.preventDefault();
                            getSearchResult();
                          }}
                        >
                          <div className="input-group input-group-sm">
                            <input
                              className="form-control form-control-navbar"
                              type="search"
                              placeholder="Search"
                              aria-label="Search"
                              value={query}
                              onChange={(event) => setQuery(event.target.value)}
                            />
                            <div className="input-group-append">
                              <button className="btn btn-navbar" type="submit">
                                <i className="fas fa-search"></i>
                              </button>
                              <button
                                className="btn btn-navbar"
                                type="button"
                                data-widget="navbar-search"
                                onClick={(event) => {
                                  setSearch(false);
                                  getPageStart();
                                }}
                              >
                                <i className="fas fa-times"></i>
                              </button>
                            </div>
                          </div>
                        </form>
                      </div>
                    </li>
                  </ul>
                </div>
                {/* /.card-header */}
                <div className="card-body">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="form-group">
                        <div className="row" style={{ marginTop: "10px" }}>
                          <div className="col-sm-12">
                            <InfiniteScroll
                              dataLength={allPage.length}
                              hasMore={hasHigh}
                              loader={<Listloader></Listloader>}
                              next={fetchData}
                            >
                              <div style={{ paddingBottom: "60px" }}>
                                <table
                                  id="appadmin"
                                  className="table table-bordered table-hover dataTable dtr-inline"
                                  role="grid"
                                  aria-describedby="example2_info"
                                >
                                  <thead>
                                    <tr role="row">
                                      <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Name
                                      </th>
                                      <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Email
                                      </th>
                                      <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Role
                                      </th>
                                      <th
                                        className="sorting_asc"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Status
                                      </th>
                                      <th
                                        className="sorting"
                                        tabIndex={0}
                                        aria-controls="example2"
                                        rowSpan={1}
                                        colSpan={1}
                                      >
                                        Actions
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {allPage.map((person, index) => (
                                      <tr
                                        role="row"
                                        className="even"
                                        key={index}
                                      >
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={0}
                                        >
                                          <a href={"#!"}>{person.name}</a>
                                        </td>
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                        >
                                          <a href={"#!"}>{person.email}</a>
                                        </td>
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={1}
                                        >
                                          <a href={"#!"}>
                                            {person.superAdmin
                                              ? "Super Admin"
                                              : person.admin
                                                ? "Admin"
                                                : person.editor
                                                  ? "Editor"
                                                  : "Viewer"}
                                          </a>
                                        </td>
                                        <td
                                          className="dtr-control sorting_1"
                                          tabIndex={2}
                                        >
                                          <a
                                            href="#!"
                                            className={
                                              person.active
                                                ? "text-center bg-lime color-palette"
                                                : "text-center"
                                            }
                                            style={{
                                              display: "block",
                                              width: "120px",
                                            }}
                                          >
                                            <label>
                                              {" "}
                                              {person.active
                                                ? "Active"
                                                : "Deactivated"}
                                            </label>
                                          </a>
                                        </td>
                                        <td>
                                          <div className="btn-group">
                                            <button
                                              type="button"
                                              className="btn btn-default"
                                            >
                                              Action
                                            </button>
                                            <button
                                              type="button"
                                              className="btn btn-default dropdown-toggle dropdown-icon"
                                              data-toggle="dropdown"
                                              aria-expanded="false"
                                            >
                                              <span className="sr-only">
                                                Toggle Dropdown
                                              </span>
                                            </button>
                                            <div
                                              className="dropdown-menu"
                                              role="menu"
                                            >
                                              <a
                                                className="dropdown-item"
                                                href={"#!"}
                                                onClick={() => {
                                                  setModalShow(true);
                                                  setSelectedUser(person);
                                                }}
                                              >
                                                Edit
                                              </a>
                                              <a
                                                className="dropdown-item"
                                                href="#!"
                                              >
                                                Change Status
                                              </a>
                                              <Link
                                                className="dropdown-item"
                                                to={{
                                                  pathname: "/changepassword",
                                                  state: {
                                                    id: person._id,
                                                    oldPassword:
                                                      person.password,
                                                  },
                                                }}
                                              >
                                                Change Password
                                              </Link>
                                              <button
                                                type="button"
                                                className="btn btn-light"
                                                onClick={(event) =>
                                                  handleDelete(
                                                    event,
                                                    person._id,
                                                    index
                                                  )
                                                }
                                                style={{
                                                  padding: "0.25rem 1rem",
                                                  marginLeft: "0.80rem",
                                                }}
                                              >
                                                <i className="fa fa-trash"></i>{" "}
                                                Delete
                                              </button>
                                            </div>
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </InfiniteScroll>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                {/* /.card-body */}
              </div>
            </div>
          </div>
        </div>
        <EditUser
          show={ModalShow}
          user={selectedUser}
          onHide={() => setModalShow(false)}
          {...props}
        />
      </section>
    );
  }
};

export default UserList;
